export const firebaseConfig = {
  apiKey: "AIzaSyAc6dlEkW2GTOcIEsHRQNBEU6CUb7CKgyk",
  authDomain: "allportal-ee7c5.firebaseapp.com",
  projectId: "allportal-ee7c5",
  storageBucket: "allportal-ee7c5.appspot.com",
  messagingSenderId: "349455033301",
  appId: "1:349455033301:web:80abf92eaadccab6ec935c",
  measurementId: "G-N961SXC0KM"
};
